import React from 'react';
import HeadlineWithFocus from "../components/HeadlineWithFocus";
import styled from 'styled-components';
import { Page, Row, Column } from 'hedron';
import ColorBar from '../components/colorbar';
import ProfileImage from '../images/robertogentile.png'
import TriangleIcon from '../images/triangle.svg';
import Poliba from '../images/curriculum/poliba.png';
import UPM from '../images/curriculum/upm.gif';
import UC from '../images/curriculum/uc.png';
import UCL from '../images/curriculum/ucl.jpg';
import rose from '../images/curriculum/rose.png';
import aleandri from '../images/curriculum/aleandri.png';
import ScrollableAnchor from 'react-scrollable-anchor';
import MainFooter from '../components/MainFooter';
import CV from '../assets/images/cv.png';



const ProfileImageWrapper = styled.div`
  border: none;
  border-bottom: 1px solid #e0e0e0;
  background-image: url(${ProfileImage});
  background-size: cover;
  background-position: 20% 22%;
  height: 280px;
  @media (min-width: 768px) {
    background-position: 60% center;
    border: none;
    height: 470px;
  }
  @media (min-width: 1400px) {
    border: none;
  }
`

const ImageWrapper = styled.div.attrs({

  image: props => props.image
})`
  background-image: url(${props => props.image});
  background-size: 100%;
  @media (max-width: 599px) {
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    height: 150px;
  }
  @media (min-width: 600px) {
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    height: 200px;
  }
`

const ImgColStyle = {
  padding: '0',
};


const RowStyleEVEN = {
  background: '#F9F9F9',
};

const RowStyleODD = {
  background: '#F5F5F5',
};

const About = props => {
    return (
        <div>
            <div style={{ height: '100%', verticalAlign: 'center', marginTop: '5%' }}>
          		<Row alignItems="flex-end" style={{ margin: '0' }}>
                  <Column xs={12} sm={12} smShift={0} md={6} lg={3} lgShift={2}>
                    <ProfileImageWrapper />
                  </Column>
                  <Column xs={12} sm={12} smShift={0} md={6} lg={4} style={{ background: '#F9F9F9' }}>
                    <h2>About</h2>
                    <ColorBar color="#A661C2" />
                    <p><strong>
                    Ciao, sono Rob. Sono un ingegnere sismico/strutturale e vivo a Londra.
                    </strong></p>
                    <p>Nel corso del dottorato al Politecnico di Bari ho scoperto la mia passione nel risolvere problemi ingegneristici programmando.</p>
                    <p style={{ marginBottom: 0 }}>
                    Presto ho cominicato a scrivere piccole app desktop per condividere quegli algoritmi, soprattutto con chi non scrive codice. Attualmente lavoro come Assistant Professor (Lecturer) alla University College London e consulente per progetti strutturali/modellazione numerica.
                    </p>
                    <p style={{ marginLeft: '35%' }}>
                       <a href="#curriculum" style={{ border: '0'  }}><img style={{ width: '30%', height: '30%' }} src={CV} alt="Check my CV" /></a>
                    </p>
                  </Column>
                  <Column>
                      <MainFooter />
                  </Column>
        		  </Row>
            </div>

        <ScrollableAnchor id={'curriculum'}>
        <h2>Breve CV</h2>
        </ScrollableAnchor>


        <h3>Esperienza lavorativa</h3>

        <Row alignItems="center" style={RowStyleODD}>
          <Column xs={12} sm={4} smShift={0} md={3} lg={2}  style={ImgColStyle}>
             <ImageWrapper image={UCL} />
          </Column>
          <Column xs={12} sm={8} smShift={0} md={9} lg={10}>
            <p><h3>Assistant Professor (Lecturer) in Catastrophe Risk Modelling</h3>
            University College of London, London, United Kingdom. Gennaio 2022 - Present</p>
            <ul>
            <li>Institute for Risk and Disaster Reduction (IRDR)</li>
            <li>Admission tutor per i programmi di master in IRDR</li>
            </ul>
          </Column>
        </Row>

        <Row alignItems="center" style={RowStyleODD}>
          <Column xs={12} sm={4} smShift={0} md={3} lg={2}  style={ImgColStyle}>
             <ImageWrapper image={UCL} />
          </Column>
          <Column xs={12} sm={8} smShift={0} md={9} lg={10}>
            <p><h3>Marie Curie Senior Research Fellow</h3>
            University College of London, London, United Kingdom. Novembre 2019 - Dicembre 2021</p>
            <ul>
            <li>Individual fellowship "MULTIRES: MULTI-level framework to enhance seismic RESilience of RC buildings"</li>
            <li>€212,934 finanziamento europeo</li>
            </ul>

            Advisor: prof. Carmine Galasso
          </Column>
        </Row>

        <Row alignItems="center" style={RowStyleODD}>
          <Column xs={12} sm={4} smShift={0} md={3} lg={2}  style={ImgColStyle}>
             <ImageWrapper image={UCL} />
          </Column>
          <Column xs={12} sm={8} smShift={0} md={9} lg={10}>
            <p><h3>Research Fellow</h3>
            University College of London, Londra, Regno Unito. Giugno 2018 - Ottobre 2019</p>
            <ul>
            <li>Partecipazione al progetto di ricerca "INSPIRE: INdonesia School Programme to Increase REsilience"</li>
            <li>Assessment del rischio sismico: analisi di fragilità e perdite</li>
            </ul>

            Advisor: prof. Carmine Galasso
          </Column>
        </Row>

        <Row alignItems="center" style={RowStyleEVEN}>
          <Column xs={12} sm={4} smShift={0} md={3} lg={2}  style={ImgColStyle}>
             <ImageWrapper image={Poliba} />
          </Column>
          <Column xs={12} sm={8} smShift={0} md={9} lg={10}>
            <p><h3>Research collaborator ed esperto della materia (progetto di ponti)</h3>
            Politecnico di Bari. Febbraio 2018 - Maggio 2018</p>
            <ul>
            <li>Ricerca nell'ambito della valutazione sismica di edifici e ponti esistenti in CA</li>
            <li>Lezioni per il corso "Teoria e progetto di ponti". 50 studenti, 40 ore</li>
            <li>Supervisione di tesi magistrali. 13 studenti, fino ad ora</li>
            </ul>
          </Column>
        </Row>

        <Row alignItems="center" style={RowStyleODD}>
          <Column xs={12} sm={4} smShift={0} md={3} lg={2}  style={ImgColStyle}>
             <ImageWrapper image={UC} />
          </Column>
          <Column xs={12} sm={8} smShift={0} md={9} lg={10}>
            <p><h3>Visiting researcher: gruppo di ricerca "SAFER & Sustainable"</h3>
            University of Canterbury, Christchurch, Nuova Zelanda. Settembre 2016 - Febbraio 2017</p>
            <ul>
            <li>Partecipazione al gruppo di lavoro per la bozza delle linee guida per l'assessment sismico della New Zealand Society for Earthquake Engineering (capitolo edifici in CA)</li>
            <li>Assessment sismico di edifici esistenti in CA: capacità residua e casi studio reali</li>
            <li>Partecipazione ai sopralluoghi dopo il terremoto di Kaikoura 2016 (Magnitudo 7.8)</li>
            </ul>

            Advisor: prof. Stefano Pampanin
          </Column>
        </Row>

        <Row alignItems="center" style={RowStyleEVEN}>
          <Column xs={12} sm={4} smShift={0} md={3} lg={2}  style={ImgColStyle}>
             <ImageWrapper image={UC} />
          </Column>
          <Column xs={12} sm={8} smShift={0} md={9} lg={10}>
            <p><h3>Visiting researcher: gruppo di ricerca "SAFER"</h3>
            University of Canterbury, Christchurch, Nuova Zelanda. Novembre 2015 -- Febbraio 2016</p>
            <ul>
            <li>Assessment sismico di edifici esistenti in CA: casi studio reali soggetti a recenti terremoti</li>
            </ul>
            Advisor: prof. Stefano Pampanin
          </Column>
        </Row>

        <Row alignItems="center" style={RowStyleODD}>
          <Column xs={12} sm={4} smShift={0} md={3} lg={2}  style={ImgColStyle}>
             <ImageWrapper image={aleandri} />
          </Column>
          <Column xs={12} sm={8} smShift={0} md={9} lg={10}>
            <p><h3>Tirocinio</h3>
            Aleandri S.p.A., Bari. Settembre 2014 - Novembre 2014</p>
            <ul>
            <li>Modello 3D di una trave precompressa in CA per la sua analisi duante le fasi di costruzione. Alcune delle fasi di costruzione sono state migliorate basandosi sui risultati ottenuti</li>
            </ul>
            Advisor: ing. Biagio Guido
          </Column>
        </Row>


        <h3>Formazione</h3>

        <Row alignItems="center" style={RowStyleODD}>
          <Column xs={12} sm={4} smShift={0} md={3} lg={2}  style={ImgColStyle}>
             <ImageWrapper image={Poliba} />
          </Column>
          <Column xs={12} sm={8} smShift={0} md={9} lg={10}>
            <p><h3>Dottorato di ricerca, ingegneria sismica</h3>
            Politecnico di Bari, Gennaio 2018, dottorato con lode</p>
            <p><b>Tesi</b><br />Estensione, miglioramento e validazione del Simple Lateral Mechanism \\ Analysis (SLaMA) per l'assessment sismico di strutture esistenti in CA</p>
            <p><b>Tutor</b><br />prof. Giuseppina Uva, prof. Domenico Raffaele, prof. Stefano Pampanin</p>
          </Column>
        </Row>

        <Row alignItems="center" style={RowStyleEVEN}>
          <Column xs={12} sm={4} smShift={0} md={3} lg={2}  style={ImgColStyle}>
             <ImageWrapper image={Poliba} />
          </Column>
          <Column xs={12} sm={8} smShift={0} md={9} lg={10}>
            <p><h3>Laurea specialistica, ingegneria edile</h3>
            Politecnico di Bari, Ottobre 2014, 110 e lode</p>
            <p><b>Tesi</b><br />Analisi parametrica di capacità per pile mofusto in CA a sezione circolare</p>
            <p>Advisor: prof. Domenico Raffaele</p>
          </Column>
        </Row>

        <Row alignItems="center" style={RowStyleODD}>
          <Column xs={12} sm={4} smShift={0} md={3} lg={2}  style={ImgColStyle}>
             <ImageWrapper image={UPM} />
          </Column>
          <Column xs={12} sm={8} smShift={0} md={9} lg={10}>
            <p><h3>Erasmus</h3>
            Universidad Politecnica de Madrid, Febrraio-Luglio 2013</p>
            <p>Advisor: prof. Pilar Izquierdo</p>
          </Column>
        </Row>

        <Row alignItems="center" style={RowStyleEVEN}>
          <Column xs={12} sm={4} smShift={0} md={3} lg={2}  style={ImgColStyle}>
             <ImageWrapper image={Poliba} />
          </Column>
          <Column xs={12} sm={8} smShift={0} md={9} lg={10}>
            <p><h3>Laurea triennale, ingegneria edile</h3>
            Politecnico di Bari, Novembre 2012, 110 e lode</p>
            <p><b>Tesi</b><br />Resistenza a taglio di travi in cemento armato con aggregati riciclati</p>
            <p>Advisor: prof. Mariella Diaferio</p>
          </Column>
        </Row>

        <Row alignItems="center" style={RowStyleODD}>
          <Column xs={12} sm={4} smShift={0} md={3} lg={2}  style={ImgColStyle}>
             <ImageWrapper image={rose} />
          </Column>
          <Column xs={12} sm={8} smShift={0} md={9} lg={10}>
            <p><h3>Corso singolo</h3>
            ROSE School (IUSS), Pavia. </p>
            <p><b>Titolo del Corso</b><br />Seismic design of low damage concrete and timber structures (160 hours)</p>
            <p>prof. Stefano Pampanin</p>
          </Column>
        </Row>

      </div>
	)
}

export default About;



// WEBPACK FOOTER //
// ./src/pages/about.it.jsx